import type { FinancialOverview } from './financial-overview-api';
import { selectMonthlyBankBalance } from '@tosho/domain';

/** One dated selection for every cash chart: prefer the later supported day,
 * without extending an old observation into a different month. */
export function balanceForPeriod(
  overview: FinancialOverview,
  period: string,
): {
  cents: string | null;
  date: string | null;
  provenance: 'observé' | 'reconstitué' | 'absent';
} {
  if (period < '2020-09' || period > (overview.observedThroughPeriod ?? overview.period))
    return { cents: null, date: null, provenance: 'absent' };
  const source = overview.remuneration?.months.find((row) => row.period === period);
  const observed =
    source?.bankCents != null && source.bankDate?.slice(0, 7) === period
      ? { cents: source.bankCents, date: source.bankDate }
      : overview.bankBalance?.cents != null && overview.bankBalance.date?.slice(0, 7) === period
        ? { cents: overview.bankBalance.cents, date: overview.bankBalance.date }
        : null;
  return selectMonthlyBankBalance(period, observed, {
    cents: source?.calculatedBankCents ?? null,
    date: source?.calculatedBankDate ?? null,
  });
}
